import { memo, type MouseEvent } from 'react';

import { css, UnstyledButton, type UnstyledButtonProps } from '@clubspark-react/ui/core';

export type LinkButtonProps = Omit<UnstyledButtonProps, 'onClick'> & {
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
};

const styles = css({
  fontFamily: '$default',
  color: '$primary100main',
  '&:hover': {
    textDecoration: 'underline',
  },
});

const LinkButton = memo(({ children, ref, ...props }: LinkButtonProps) => {
  return (
    <UnstyledButton
      {...props}
      ref={ref}
      classNames={{
        unstyled: styles(),
      }}
      styles={{
        label: {
          lineHeight: 'unset',
        },
      }}
    >
      {children}
    </UnstyledButton>
  );
});

export default LinkButton;
